import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
/**
 * Task template select component specifically for the capacity report.
 * Filters task templates based on those that have scheduled work in the selected period.
 */
export const CapacityTaskSelect = ({ initialValue, placeholder, availableTemplateIds, onChange, }) => {
    const { formatMessage } = useIntl();
    const { data } = useGetTaskTemplates();
    const taskTemplates = useMemo(() => {
        if (!data)
            return undefined;
        // Filter by available templates if provided
        const filtered = availableTemplateIds && availableTemplateIds.length > 0
            ? data.filter(item => availableTemplateIds.includes(item.id))
            : data;
        return filtered
            .map(item => ({
            key: item.id,
            label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
            resourceId: item.resourceId,
        }))
            .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
    }, [data, availableTemplateIds, formatMessage]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (taskTemplates === null || taskTemplates === void 0 ? void 0 : taskTemplates.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, taskTemplates]);
    const componentKey = useMemo(() => {
        if (!availableTemplateIds || availableTemplateIds.length === 0) {
            return 'all-templates';
        }
        // Create a stable key from sorted IDs
        return availableTemplateIds
            .slice()
            .sort()
            .join('-');
    }, [availableTemplateIds]);
    return (_jsx(AutoComplete, { items: taskTemplates, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key) }, componentKey));
};
